module.exports = __webpack_public_path__ + "img/bg_g.3a502af6.png";